<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import MainLayout from '@/layouts/MainLayout.vue'

const authStore = useAuthStore()

onMounted(async () => {
  // Skip auth check on public routes — use window.location since
  // router.currentRoute may not have resolved yet at mount time
  const publicPaths = ['/login', '/bglogin', '/staff-login', '/extension', '/eula', '/privacy-policy', '/survey', '/burn']
  const isPublic = publicPaths.some(p => window.location.pathname.startsWith(p))
  if (!isPublic) {
    await authStore.fetchUser()
  }
})
</script>

<template><MainLayout /></template>
